import React from 'react';
import './index.scss';

export default ({ type, onClick, ...rest }) => {
    const base = type === 'warning' ? 'footer-warning' : type === 'info' ? 'footer-info' : 'footer';
    return <footer className={onClick ? base + ' footer-clickable' : base} onClick={onClick} {...rest} />;
};
